import React, { type FC, createContext, useContext, useMemo } from "react"

interface CompanyFilesContextType {
  isActiveCompany: boolean
  onRefresh: () => Promise<void>
}

const CompanyFilesContext = createContext<CompanyFilesContextType>({
  isActiveCompany: false,
  onRefresh: async () => {},
})

export const CompanyFilesProvider: FC<{
  isActiveCompany: boolean
  onRefresh: () => Promise<void>
  children: React.ReactNode
}> = ({ isActiveCompany, onRefresh, children }) => {
  const contextValue = useMemo(() => ({ isActiveCompany, onRefresh }), [isActiveCompany, onRefresh])
  return <CompanyFilesContext.Provider value={contextValue}>{children}</CompanyFilesContext.Provider>
}

export const useCompanyFilesContext = (): CompanyFilesContextType => {
  return useContext(CompanyFilesContext)
}
